import React, { Component } from 'react';
import KithNavbar from "../../../Navbar/KithNavbar/index";
import KithInfoSubNavbar from "../../../Navbar/KithInfoSubNavbar";
import KithFooter from "../../../KithFooter/index";
import './faqk.css';
class faqk extends Component {
    render() {
        return (
            <div>
                <KithNavbar/>
                <KithInfoSubNavbar/>
                <section className='faq-kith'>                                  
                <div className='faq-head'>Frequently Ask Question </div>
                <p className='faqk-p'>
                Thank you for your interest in supporting Lokarpan/Kith. Should you have any inquiries or need help with your donation, you’re welcome to: 
                </p>
                
                    <div className='faqk-qna'>
                        <div className='faq-q'>1. How Do I Apply For Admission To Kith School?</div>
                        <ul className='faqk-a'>
                            <li>For admission to Kith n Kin School, all applications must be submitted either through our admissions portal or in person at the admissions office. If you're not yet prepared to apply, you can register your interest to receive updates on our website. Click here to begin your application or to register your interest.
</li>
                           
                        </ul>
                    </div>
                    <div className='faqk-qna'>
                        <div  className='faq-q'>2. How Many Students Are At Kith School And What Is The Average Class Size?</div>
                        <ul className='faqk-a'>
                            <li>Kith typically has 565 students in total. It varies according to age and subject, but it is usually between twenty and thirty five students per class.
</li>
                           
                        </ul>
                    </div>
                    <div className='faqk-qna'>
                        <div  className='faq-q'>3.Which Countries Are Represented Among Kith School Students?
</div>
                        <ul className='faqk-a'>
                            <li>Recent students at Kith School hail from India.

</li>
                            
                        </ul>
                    </div>
                    <div className='faqk-qna'>
                        <div  className='faq-q'>4.Can I book a tour or visit the campus?
</div>
                        <ul className='faqk-a'>
                            <li>You can contact us by email or on the telephone numbers below. Lines are manned between 8:30am and 5:30pm IST during term time.
</li>
                           
                        </ul>
                    </div>
                    <div className='faqk-qna'>
                        <div  className='faq-q'>5. Is Kith School Accredited?</div>
                        <ul className='faqk-a'>
                            <li>Kith is accredited by the Uttar Pradesh State Board, which was established in 1921 in Prayagraj by an Act of the United Provinces Legislative Council. Presently, the Board stands as the largest examining body globally.
</li>
                                </ul>
                    </div>
                    <div className='faqk-qna'>
                        <div  className='faq-q'>6.What Is The Curriculum Offered At Kith School?
</div>
                        <ul className='faqk-a'>
                            <li>At Kith, our curriculum epitomises excellence, drawing on cutting-edge educational research to deliver a rigorous and globally relevant learning experience. Aligned with State Board standards, our program ensures students receive a high-quality education that fosters critical thinking, creativity, and a nuanced understanding of diverse perspectives. We equip our students with the skills and knowledge needed to excel in today's dynamic global landscape.
</li>
                            
                        </ul>
                    </div>
                    <div  className='faqk-qna'>
                        <div  className='faq-q'>7. What Extracurricular Opportunities Are Available At Kith School?
</div>
                        <ul className='faqk-a'>
                            <li>At Kith, students immerse themselves in a diverse range of extracurricular activities designed to nurture their artistic talents and personal growth. From music to dance to visual arts, our offerings span classroom instruction, weekend courses, performance ensembles, and private lessons facilitated by our esteemed international faculty. Participation in activities such as band, choir, dance, painting, digital arts, model making, business classes, photography, Indian music, and private instruction is determined through a placement audition, ensuring alignment with each student's abilities and schedule.
</li>
<li>While some courses require auditions, many are open to all students, fostering a culture of inclusivity and exploration. Compulsory classroom courses, essential for building a foundational understanding of liberal arts, are provided from PG to Grade 8. Additionally, optional courses like "Summer of Code" cater to Grades 7 through 12.</li>
<li>Private instruction, highly sought after and competitive, follows a tiered allocation process, prioritising returning students, those with prior experience, and then beginners.</li>
                               </ul>
                    </div>

                    <div  className='faqk-qna'>
                        <div  className='faq-q'>8. What Second Languages Does Kith School Offer?
</div>
                        <ul className='faqk-a'>
                            <li>At Kith, students have the opportunity to explore a variety of second languages, including Sanskrit, French, Spanish, and Hindi. Additionally, we provide comprehensive English programs to support students who require assistance with English proficiency.
</li>
                               </ul>
                    </div>

                    <div  className='faqk-qna'>
                        <div  className='faq-q'>9. What Is The Average Retention For Students And Staff At Kith School?
</div>
                        <ul className='faqk-a'>
                            <li>At Kith n Kin School, we're proud to boast an impressively high student retention rate. This means that many of our students stay with us throughout their academic journey, forming lasting bonds with classmates and staff members alike. This continuity not only fosters lifelong friendships but also allows students the time to fully embrace our educational philosophy and curriculum.
</li>
<li>In terms of staff, we have a mix of both long-serving educators and those who may spend two to four years with us. However, we're committed to encouraging the majority of our staff to stay for a minimum of five to six years. To support this commitment, we offer competitive salaries, contracts and benefit packages, along with opportunities for professional development.
</li>
<li>Additionally, we're fortunate to welcome a diverse group of international faculty, guest lecturers, and fellows who generously contribute their time and expertise to our school community. Their involvement enriches our academic environment and provides students with unique perspectives and experiences.</li>
                               </ul>
                    </div>

                    <div  className='faqk-qna'>
                        <div  className='faq-q'>10. What Sports Does Kith School Offer?
</div>
                        <ul className='faqk-a'>
                            <li>Table tennis, badminton, swimming, gymnastics, athletics, cricket, cross-country, road running, field hockey, personal fitness, football (soccer), basketball and volleyball.
</li>
                               </ul>
                    </div>

                    <div  className='faqk-qna'>
                        <div  className='faq-q'>11. Does Kith Conduct And Participate In Inter-School Activities?
</div>
                        <ul className='faqk-a'>
                            <li>Kith students have a number of opportunities to interact with students from other schools in and around Malhausi, across India and internationally.
</li>
                               </ul>
                    </div>

                    <div  className='faqk-qna'>
                        <div  className='faq-q'>12. Which Grade Should I Apply For?
</div>
                        <ul className='faqk-a'>
                            <li>At Kith, we adhere to the age matrix recommended by the Government of India. We welcome parents and guardians to apply for admission for their children. You can view the age matrix by clicking here.
</li>
                               </ul>
                    </div>

                    <div  className='faqk-qna'>
                        <div  className='faq-q'>13. What Health Care Facilities Does Kith Have?
</div>
                        <ul className='faqk-a'>
                            <li>At Kith n Kin School, our Health Centre is available to provide immediate assistance for basic ailments and minor injuries commonly encountered during school activities. Our facility is equipped to offer initial care and support to students in need.
</li>
                               </ul>
                    </div>

                    <div  className='faqk-qna'>
                        <div  className='faq-q'>14. Are There Any Special Arrangements For Children With Chronic Medical Conditions?
</div>
                        <ul className='faqk-a'>
                            <li>We recognise the life-threatening nature of certain medical conditions and their potential impact on a child's ability to learn. Our school's medical policy emphasises the importance of treating each child with a medical condition as an individual, acknowledging their unique needs. However, we currently lack specialised arrangements on school premises to support specific medical conditions that may require additional assistance.
</li>
                               </ul>
                    </div>
                    </section>
                    <div className="footer-content">
          <p>
          Before applying to Kith, please explore our website for information on our programs, residences, staff, students, fees, and the admissions process. 

In our discussions with those considering the Kith n Kin School for their children, we've noticed some questions come up often. You'll find answers to these common queries on this page.

We hope this helps as you consider joining our community.

If you have any additional questions, please do not hesitate to email us at support@lokarpan.com

          </p>
          <hr className="hor-line4" />
        </div>
                <KithFooter/>
            </div>
        );
    }
}

export default faqk;